import Basic from '@/components/page/Basic.js'
import { Penanggalan, AxiosWithJar, Config } from '@/utility.js'

export default{
	extends: Basic,
	props:[],
	data:()=>({
        clearing: {uncleared:[]},
		loading: { table:true },
	}),
	methods:{
	

	},
    computed: {
		
    }
}